import React from "react";
import { Spin } from "antd";

const FixedSpinner = ({ loading, children, ...otherProps }) => (
    <Spin
        spinning={loading}
        style={{
            position: "fixed",
            minHeight: "100vh",
            minWidth: "100vw",
            top: 0,
        }}
        {...otherProps}
    >
        {children}
    </Spin>
);

export default FixedSpinner;
